<template>
  <b-modal id="modal-retur" hide-header hide-footer ok-only ok-title="Accept" centered size="lg" title="Large Modal"
    modal-class="custom__modal--large" @show="handleOpenModal">
    <header class="sticky-top border border-light-bottom border-light-line border-light-top border-light-line p-2">
      <b-row>
        <b-col cols="3" class="d-flex align-items-center">
          <div style="cursor: pointer" @click="$bvModal.hide('modal-retur')">
            <feather-icon size="24" class="text-dark font-weight-bolder" icon="ArrowLeftIcon" />
            <span class="text-dark text-darken-4 fw-bold-600 size14 ml-1">Kembali</span>
          </div>
        </b-col>
        <b-col cols="6" class="d-flex justify-content-center align-items-center">
          <h1 class="text-dark h6 font-weight-bolder mb-0 text-center">
            <span class="text-dark h6 font-weight-bolder mb-0 text-center" v-if="returs && returs.invoice_number">No
              Invoice:</span>
            {{
              is_edit == false
                ? (returs && returs.invoice_number) || "Tambah Retur Pembelian"
                : (returs.transaction && returs.transaction.invoice_number) ||
                (returs.transaction && returs.transaction.po_so_id)
            }}
            {{
              is_edit === true ? `&bull; No Retur: ${returs.retur_number}` : ""
            }}
          </h1>
        </b-col>
        <b-col cols="3" class="text-right">
          <b-button v-if="isApprove == false" class="px-3" :disabled="disabledApprove || isLoading"
            @click="submit(null)">
            {{ is_edit == true ? "Update Retur" : "Tambah Retur" }}
          </b-button>
        </b-col>
      </b-row>
    </header>
    <b-container fluid class="mt-5 pt-1">
      <b-row class="mx-0 mt-5 justify-content-center">
        <b-col class="" cols="12">
          <b-table class="mb-0" responsive :items="items" :fields="fields">
            <!-- A custom formatted header cell for field 'name' -->
            <template #head(name)="">
              <span>Nama Barang</span>
            </template>
            <template #head(qty)="">
              <span>Jumlah Barang</span>
            </template>
            <template #head(count)="" style="width: 9rem">
              <span>Jumlah Retur</span>
            </template>
            <template #head(normal_selling_value)="">
              <span>Nilai Jual Normal</span>
            </template>
            <template #head(discount_per_item)="">
              <span>Diskon Jual per Item</span>
            </template>
            <template #head(discount_per_invoice)="">
              <span>Diskon Jual per Invoice</span>
            </template>
            <template #head(value)="">
              <span>Nilai Retur</span>
            </template>
            <template #head(condition)="">
              <span>Kondisi Barang</span>
            </template>

            <!-- A custom formatted column -->
            <template #cell(count)="data">
              <b-form-group label="" label-for="v-jumlah-retur" class="pr-1 custom__form--input">
                <input :id="`v-jumlah-retur-${data.index}`" type="text" class="custom__input pl-1" style="width: 9rem"
                  @input="getRupiah(data.index)" @change="getRupiah(data.index)" :disabled="$route.name === 'retur.index'" />
              </b-form-group>
            </template>

            <template #cell(value)="data">
              <span>{{ totalSumRetur(data.item.uuid) | formatAmount }}</span>
            </template>

            <template #cell(qty)="data">
              <span>{{ getAvailableQty(data.item.uuid) }}</span>
            </template>

            <template #cell(name)="data">
              <div class="d-flex align-items-center">
                <span>{{ data.value }}</span>
                
                <!-- Badge / Icon Barang Bonus -->
                <b-badge 
                  v-if="data.item.is_bonus" 
                  variant="light-warning" 
                  class="ml-1 text-uppercase"
                  style="font-size: 10px; padding: 4px 6px;"
                >
                  <feather-icon icon="GiftIcon" size="12" class="mr-25" />
                  <span style="color: black;">Bonus</span>
                </b-badge>
              </div>
            </template>

            <!-- A custom formatted column -->
            <template #cell(condition)="data">
              <b-form-group label="" class="custom__form--input">
                <b-form-select v-model="formPayload.items[data.index].condition" label="title" :options="options"
                  :disabled="qty[data.index].qty == 0 ? true : false" />
                <!-- class="error-validation" -->
              </b-form-group>
              <small v-if="
                messages[`items.${data.index}.condition`] &&
                Array.isArray(messages[`items.${data.index}.condition`]) &&
                messages[`items.${data.index}.condition`].length > 0
              " class="text-error fw-bold-500 size12">{{
                  messages[`items.${data.index}.condition`].join(", ")
                }}</small>
              <small v-else-if="
                messages && Array.isArray(messages) && messages.length > 0
              " class="text-error fw-bold-500 size12">{{ messages.join(", ") }}</small>
            </template>

            <template #cell(normal_selling_value)="data">
              <span>
                {{ calculateValue(data.item.uuid, 'normal_selling_value') | formatAmount }}
              </span>
            </template>
            <template #cell(discount_per_item)="data">
              <span>
                {{ calculateValue(data.item.uuid, 'discount_per_item') | formatAmount }}
              </span>
            </template>
            <template #cell(discount_per_invoice)="data">
              <span>
                {{ calculateValue(data.item.uuid, 'discount_per_invoice') | formatAmount }}
              </span>
            </template>
          </b-table>
        </b-col>
        <b-col md="6" />
        <b-col md="6" class="border-left border-bottom py-5 mb-5 pl-3">
          <b-row>
            <b-col cols="4">
              <h6 class="text-dark fw-bold-600 mb-3 text-center">
                Total Nilai Retur
              </h6>
            </b-col>
            <b-col cols="8">
              <span class="text-dark fw-bold-600 mb-3">{{
                totalRetur || 0 | formatAmount
              }}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="mb-3 align-self-center">
              <h6 class="text-dark fw-bold-600 text-center">
                Input Nilai Diskon
              </h6>
            </b-col>
            <b-col cols="8" class="mb-3">
              <span v-if="is_edit == true" class="text-dark fw-bold-600">{{
                formPayload.discount | formatAmount
              }}</span>
              <b-form-group v-else label="" label-for="v-discount" class="mr-5">
                <money id="v-discount" v-model="discountValue" v-bind="money" placeholder="Jumlah Retur"
                  class="custom__input px-1" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <h6 class="text-dark fw-bold-600 mb-3 text-center">
                Total Pengembalian
              </h6>
            </b-col>
            <b-col cols="8">
              <span class="text-dark fw-bold-800 mb-3">{{ totalPengembalian | formatAmount }}</span>
            </b-col>
          </b-row>
          <div v-if="userPaymentPoint || userPaymentPiutang || (userPaymentWallet && userPaymentPiutang)">
            <b-row v-if="((userPaymentPiutang && totalPengembalian <= userUnpaidPiutang) || !userPaymentPiutang || isTransactionSuccess) && !userPaymentPoint && !userPaymentWallet && !checkHasWalletAndPiutang()">
              <b-col cols="4" style="display: grid; place-items: center">
                <h6 class="text-dark fw-bold-600 mb-0 text-center">
                  Metode Pembayaran
                </h6>
              </b-col>
              <b-col cols="8" v-if="$route.name === 'transaction.index'">
                <b-form-group label="" class="custom__form--input mb-0">
                  <v-select v-model="formPayload.refund_method" label="title" :options="optionsBank"
                    :reduce="(option) => option.value" :selectable="option => !option.disabled" placeholder="Pilih Metode Pembayaran">
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col cols="8" v-else>
                <b-form-group label="" class="custom__form--input mb-0">
                  <v-select v-model="formPayload.refund_method" label="title" :options="optionsBank"
                    :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" :disabled="formPayload.refund_method !== null">
                    <template v-slot:option="option">
                      {{ option.title }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="userPaymentPoint && !isValidReturnPoint && !userPaymentPiutang && !checkHasPointAndPiutang()">
              <b-col cols="4" style="display: grid; place-items: center">
                <h6 class="text-dark fw-bold-600 mb-0 text-center">
                  Metode Pembayaran
                </h6>
              </b-col>
              <b-col cols="8" v-if="$route.name === 'transaction.index'">
                <b-form-group label="" class="custom__form--input mb-0">
                  <v-select v-model="formPayload.refund_method" label="title" :options="optionsBank"
                    :reduce="(option) => option.value" :selectable="option => !option.disabled" placeholder="Pilih Metode Pembayaran">
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col cols="8" v-else>
                <b-form-group label="" class="custom__form--input mb-0">
                  <v-select v-model="formPayload.refund_method" label="title" :options="optionsBank"
                    :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" :disabled="formPayload.refund_method !== null">
                    <template v-slot:option="option">
                      {{ option.title }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="checkHasPointAndPiutang() && !isValidReturnPiutang2 && !isValidReturnPoint">
              <b-col cols="4" style="display: grid; place-items: center">
                <h6 class="text-dark fw-bold-600 mb-0 text-center">
                  Metode Pembayaran
                </h6>
              </b-col>
              <b-col cols="8" v-if="$route.name === 'transaction.index'">
                <b-form-group label="" class="custom__form--input mb-0">
                  <v-select v-model="formPayload.refund_method" label="title" :options="optionsBank"
                    :reduce="(option) => option.value" :selectable="option => !option.disabled" placeholder="Pilih Metode Pembayaran">
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col cols="8" v-else>
                <b-form-group label="" class="custom__form--input mb-0">
                  <v-select v-model="formPayload.refund_method" label="title" :options="optionsBank"
                    :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" :disabled="formPayload.refund_method !== null">
                    <template v-slot:option="option">
                      {{ option.title }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <b-row v-if="!userPaymentPoint && !userPaymentPiutang && !userPaymentWallet && $route.name !== 'retur.index'">
            <b-col cols="4" style="display: grid; place-items: center">
              <h6 class="text-dark fw-bold-600 mb-0 text-center">
                Metode Pembayaran
              </h6>
            </b-col>
            <b-col cols="8" v-if="$route.name === 'transaction.index'">
              <b-form-group label="" class="custom__form--input mb-0">
                <v-select v-model="formPayload.refund_method" label="title" :options="optionsBank"
                  :reduce="(option) => option.value" :selectable="option => !option.disabled" placeholder="Pilih Metode Pembayaran">
                </v-select>
              </b-form-group>
            </b-col>
            <b-col cols="8" v-else>
              <b-form-group label="" class="custom__form--input mb-0">
                <v-select v-model="formPayload.refund_method" label="title" :options="optionsBank"
                  :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" :disabled="formPayload.refund_method !== null">
                  <template v-slot:option="option">
                    {{ option.title }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="(userPaymentWallet && !isValidReturnWallet && !userPaymentPiutang && !userPaymentPoint) && !checkHasWalletAndPiutang() && !(userPaymentWallet && isTransactionSuccess && isSplitPayments && isValidReturnWallet) && $route.name !== 'retur.index'">
            <b-col cols="4" style="display: grid; place-items: center">
              <h6 class="text-dark fw-bold-600 mb-0 text-center">
                Metode Pembayaran
              </h6>
            </b-col>
            <b-col cols="8" v-if="$route.name === 'transaction.index'">
              <b-form-group label="" class="custom__form--input mb-0">
                <v-select v-model="formPayload.refund_method" label="title" :options="optionsBank"
                  :reduce="(option) => option.value" :selectable="option => !option.disabled" placeholder="Pilih Metode Pembayaran">
                </v-select>
              </b-form-group>
            </b-col>
            <b-col cols="8" v-else>
              <b-form-group label="" class="custom__form--input mb-0">
                <v-select v-model="formPayload.refund_method" label="title" :options="optionsBank"
                  :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" :disabled="formPayload.refund_method !== null">
                  <template v-slot:option="option">
                    {{ option.title }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <div v-if="$route.name === 'transaction.index' && userPaymentPiutang && totalPengembalian > userUnpaidPiutang && !isTransactionSuccess && !userPaymentPoint && !checkHasWalletAndPiutang()">
            <b-row class="mb-1" v-for="item, index in sortedPaymentPiutang" :key="index">
              <b-col cols="4" style="display: grid; place-items: center">
                <h6 class="text-dark fw-bold-600 mb-0 text-center">
                  Metode Pembayaran {{ index + 1 }}
                </h6>
              </b-col>
              <b-col cols="8" >
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="" class="custom__form--input mb-0">
                      <v-select class="split--group" v-model="formPayload.payment_method_details[index].payment_method" label="title" :options="optionsBankSplit.default"
                        :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" disabled v-if="formPayload.payment_method_details[index].payment_method === 'piutang'">
                      </v-select>
                      <v-select v-model="formPayload.payment_method_details[index].payment_method" label="title" :options="optionsBankSplit.others"
                        :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" v-else>
                      </v-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6" class="align-content-center custom__input">
                    <span class="text-dark fw-bold-600">{{ item.payment_method === 'piutang' ? item.unpaid : totalAmountPaymentMethodPiutang }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <!-- Point -->
          <div v-if="$route.name === 'transaction.index' && userPaymentPoint && isTransactionSuccess && isSplitPayments && isValidReturnPoint && !userPaymentPiutang">
            <b-row class="mb-1" v-for="item, index in sortedPaymentPoint" :key="index">
              <b-col cols="4" style="display: grid; place-items: center">
                <h6 class="text-dark fw-bold-600 mb-0 text-center">
                  Metode Pembayaran {{ index + 1 }}
                </h6>
              </b-col>
              <b-col cols="8" >
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="" class="custom__form--input mb-0">
                      <v-select class="split--group" v-model="formPayload.payment_method_details[index].payment_method" label="title" :options="optionsBankSplitPoint.default"
                        :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" disabled v-if="formPayload.payment_method_details[index].payment_method === 'point'">
                      </v-select>
                      <v-select v-model="formPayload.payment_method_details[index].payment_method" label="title" :options="optionsBankSplitPoint.others"
                        :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" v-else>
                      </v-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6" class="align-content-center custom__input">
                    <span class="text-dark fw-bold-600">{{ item.payment_method === 'point' ? item.amount - item.total_return_point_amount : totalAmountPaymentMethodWithPoint  | formatPoint}}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <!-- Wallet -->
          <div v-if="$route.name === 'transaction.index' && userPaymentWallet && isTransactionSuccess && isSplitPayments && isValidReturnWallet && !checkHasWalletAndPiutang()">
            <b-row class="mb-1" v-for="item, index in sortedPaymentWallet" :key="index">
              <b-col cols="4" style="display: grid; place-items: center">
                <h6 class="text-dark fw-bold-600 mb-0 text-center">
                  Metode Pembayaran {{ index + 1 }}
                </h6>
              </b-col>
              <b-col cols="8" >
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="" class="custom__form--input mb-0">
                      <v-select class="split--group" v-model="formPayload.payment_method_details[index].payment_method" label="title" :options="optionsBankSplitWallet.default"
                        :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" disabled v-if="formPayload.payment_method_details[index].payment_method === 'wallet'">
                      </v-select>
                      <v-select v-model="formPayload.payment_method_details[index].payment_method" label="title" :options="optionsBankSplitWallet.others"
                        :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" v-else>
                      </v-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6" class="align-content-center custom__input">
                    <span class="text-dark fw-bold-600">{{ item.payment_method === 'wallet' ? item.amount : totalAmountPaymentMethodWithWallet | formatPoint }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <!-- Wallet and Piutang -->
          <div v-if="$route.name === 'transaction.index' && checkHasWalletAndPiutang() && isSplitPayments">
            <b-row class="mb-1" v-for="item, index in sortedPaymentWalletPiutang" :key="'wp-' + index">
              <b-col cols="4" style="display: grid; place-items: center" v-if="item.payment_method === 'piutang' || (item.payment_method === 'wallet' && walletPiutangSplitAmounts.wallet > 0)">
                <h6 class="text-dark fw-bold-600 mb-0 text-center">
                  Metode Pembayaran {{ index + 1 }}
                </h6>
              </b-col>
              <b-col cols="8" v-if="item.payment_method === 'piutang' || (item.payment_method === 'wallet' && walletPiutangSplitAmounts.wallet > 0)">
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="" class="custom__form--input mb-0">
                      <v-select
                        class="split--group"
                        v-model="formPayload.payment_method_details[index].payment_method"
                        label="title"
                        :options="item.payment_method === 'wallet' ? optionsBankSplitWallet.default : (item.payment_method === 'piutang' ? optionsBankSplit.default : optionsBankSplitWallet.others)"
                        :reduce="(option) => option.value"
                        placeholder="Pilih Metode Pembayaran"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6" class="align-content-center custom__input">
                    <span class="text-dark fw-bold-600">{{ item.payment_method === 'wallet' ? walletPiutangSplitAmounts.wallet : walletPiutangSplitAmounts.piutang | formatAmount }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <!-- Piutang and Point -->
          <div v-if="$route.name === 'transaction.index' && checkHasPointAndPiutang() && isSplitPayments && (isValidReturnPiutang2 || isValidReturnPoint)">
            <b-row class="mb-1" v-for="item, index in filteredPaymentsPointPiutang" :key="index">
              <b-col cols="4" style="display: grid; place-items: center" v-if="formPayload.payment_method_details[index].amount !== 0">
                <h6 class="text-dark fw-bold-600 mb-0 text-center">
                  Metode Pembayaran {{ index + 1 }}
                </h6>
              </b-col>
              <b-col cols="8" v-if="formPayload.payment_method_details[index].amount !== 0">
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="" class="custom__form--input mb-0">
                      <v-select class="split--group" v-model="formPayload.payment_method_details[index].payment_method" label="title" :options="optionsBank"
                        :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" disabled v-if="formPayload.payment_method_details[index].payment_method === 'point'">
                      </v-select>
                      <v-select class="split--group" v-model="formPayload.payment_method_details[index].payment_method" label="title" :options="optionsBankPiutang"
                        :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" item-props="props" :disabled="isDisabledPiutang" v-else-if="index === 1 && item.payment_method === 'piutang' && results.status === 'success'">
                      </v-select>
                      <v-select class="split--group" v-model="formPayload.payment_method_details[index].payment_method" label="title" :options="optionsBank"
                        :reduce="(option) => option.value" placeholder="Pilih Metode Pembayaran" :disabled="isDisabledPiutang" v-else>
                      </v-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6" class="align-content-center custom__input" v-if="results.status !== 'success'">
                    <span class="text-dark fw-bold-600">{{ formPayload.payment_method_details[index].amount | formatPoint}}</span>
                  </b-col>
                  <b-col cols="6" class="align-content-center custom__input" v-else>
                    <span class="text-dark fw-bold-600">{{ item.payment_method === 'point' ? item.amount - item.total_return_point_amount : totalAmountPaymentMethodWithPoint  | formatPoint}}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <div v-if="$route.name === 'retur.index'">
            <b-row class="mb-1" v-for="item, index in paymentMethodDetails" :key="index">
              <b-col cols="4" style="display: grid; place-items: center">
                <h6 class="text-dark fw-bold-600 mb-0 text-center">
                  Metode Pembayaran {{ index + 1 }}
                </h6>
              </b-col>
              <b-col cols="8" >
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="" class="custom__form--input mb-0">
                      <b-form-input :value="item.payment_method === 'wallet' ? 'Deposit' : item.payment_method" disabled class="custom__input text-capitalize" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6" class="align-content-center custom__input">
                    <span class="text-dark fw-bold-600">{{ item.amount | formatAmount }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <div v-if="isApprove" class="footer__purchase p-2">
        <b-row class="mx-0 align-items-center">
          <b-col lg="6">
            <h5 class="mb-0">Pilih persetujuan retur</h5>
          </b-col>
          <b-col lg="6">
            <div class="d-flex" v-if="!isLoading">
              <b-button class="btn-reject btn-block mr-1 py-2 size14" @click="submit('reject')">
                Tolak
              </b-button>
              <b-button class="btn-primary btn-block py-2 size14 mt-0"
                :disabled="disabledApprove || formPayload.refund_method === ''" @click="submit('approve')" v-if="returType === 'order'">
                Approve
              </b-button>
              <b-button class="btn-primary btn-block py-2 size14 mt-0"
                :disabled="disabledApprove" @click="submit('approve')" v-else>
                Approve
              </b-button>
            </div>
            <div class="d-flex" v-else>
              <b-button :disabled="true" class="btn-reject btn-block mr-1 py-2 size14" @click="submit('reject')">
                Tolak
              </b-button>
              <b-button class="btn-primary btn-block py-2 size14 mt-0"
                :disabled="true" v-if="returType === 'order'">
                <b-spinner small />
                Approve
              </b-button>
              <b-button class="btn-primary btn-block py-2 size14 mt-0"
                :disabled="true" @click="submit('approve')" v-else>
                <b-spinner small />
                Approve
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  BRow,
  BCol,
  BContainer,
  BTable,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BCard,
  BSpinner,
  BBadge,
} from "bootstrap-vue";
import {
  checkPermission,
  successNotification,
  errorNotification,
  formatRupiah,
  preformatFloat,
} from "@/auth/utils";
import vSelect from "vue-select";

export default {
  components: {
    BButton,
    BModal,
    BRow,
    BCol,
    BContainer,
    BTable,
    BFormGroup,
    BFormInput,
    BFormSelect,
    vSelect,
    BCard,
    BSpinner,
    BBadge,
  },
  props: {
    results: {
      type: Object,
    },
    is_edit: {
      type: Boolean,
      default: false,
    },
    returType: {
      type: String,
    },
    getData: {
      type: Function,
    },
    isApprove: {
      type: Boolean,
    },
  },
  setup() {
    return {
      checkPermission,
      successNotification,
      errorNotification,
      formatRupiah,
      preformatFloat,
    };
  },
  computed: {
    disabledApprove() {
      return this.formPayload.items.every((e) => e.qty <= 0 || isNaN(e.qty));
    },
    sortedPaymentPiutang() {
      return this.results?.payments?.slice().sort((a, b) => {
        return (b.payment_method === 'piutang') - (a.payment_method === 'piutang');
      });
    },
    sortedPaymentPoint() {
      return this.results?.payments?.slice().sort((a, b) => {
        return (b.payment_method === 'point') - (a.payment_method === 'point');
      });
    },
    sortedPaymentWallet() {
      return this.results?.payments?.slice().sort((a, b) => {
        return (b.payment_method === 'wallet') - (a.payment_method === 'wallet');
      });
    },
    sortedPaymentWalletPiutang() {
      // piutang first, then wallet
      return this.results?.payments?.slice().sort((a, b) => {
        const order = ['piutang', 'wallet'];
        return order.indexOf(a.payment_method) - order.indexOf(b.payment_method);
      }) || [];
    },
    userPaymentPiutang() {
      return this.results?.payments?.find(e => e.payment_method === 'piutang') || null
    },
    userPaymentPoint() {
      return this.results?.payments?.find(e => e.payment_method === 'point') || null
    },
    userPaymentWallet() {
      return this.results?.payments?.find(e => e.payment_method === 'wallet') || null
    },
    totalPengembalian() {
      return (this.totalRetur - (this.formPayload?.discount || 0)) || 0
    },
    userUnpaidPiutang() {
      return this.results?.payments?.find(e => e.payment_method === 'piutang')?.unpaid || 0
    },
    customerPoint() {
      return this.results?.loyalty_point || 0
    },
    totalAmountPaymentMethodPiutang() {
      return (this.totalRetur - this.userUnpaidPiutang) - this.formPayload.discount || 0
    },
    totalAmountPaymentMethodWithPoint() {
      if (this.totalRetur <= 0) return 0;
      const isPointPaidOff = this.userPaymentPoint.amount === this.userPaymentPoint.total_return_point_amount

      const remainderAfterPoint = isPointPaidOff ? this.totalRetur : this.totalRetur - (this.userPaymentPoint?.amount - this.userPaymentPoint.total_return_point_amount);
      const result = remainderAfterPoint - this.formPayload.discount;

      return Math.max(result, 0);
    },
    totalAmountPaymentMethodWithWallet() {
      if (this.totalRetur <= 0) return 0;
      const isWalletPaidOff = this.userPaymentWallet.amount === this.userPaymentWallet?.total_return_wallet_amount

      const remainderAfterPoint = isWalletPaidOff ? this.totalRetur : this.totalRetur - (this.userPaymentWallet?.amount - this.userPaymentWallet?.total_return_wallet_amount);

      const result = remainderAfterPoint - this.formPayload.discount;

      return Math.max(result, 0);
    },
    isTransactionSuccess() {
      return this.results.status === 'success'
    },
    isSplitPayments() {
      if (this.$route.name === 'transaction.index') {
        return this.results?.payments?.length > 1 || false
      }
      if (this.$route.name === 'retur.index') {
        return this.results?.is_split_payment_method
      }
      return false
    },
    paymentMethodDetails () {
      return this.results?.payment_method_details?.slice().sort((a, b) => {
        return (b.payment_method === 'piutang') - (a.payment_method === 'piutang');
      });
    },
    totalSumFromSubTotal() {
      let total = 0
      if (this.$route.name === 'transaction.index') {
        total = this.results.items.reduce((sum, e) => sum + e.subtotal, 0);
      }
      if (this.$route.name === 'retur.index') {
        total = this.results.items.reduce((sum, e) => sum + e.item.subtotal, 0);
      }

      return total || 0
    },
    currentPageType() {
      return this.$route.name;
    },
    isValidReturnPoint() {
      const userPaymentPoint = this.userPaymentPoint;
      if (!userPaymentPoint) return false;

      // Coerce to numbers; fall back to 0 if undefined/null/NaN
      const amount = Number(userPaymentPoint.amount) || 0;
      const used   = Number(userPaymentPoint.total_return_point_amount) || 0;
      const total  = Number(this.totalPengembalian) || 0;
      const restPointRetur = amount - used
      if (restPointRetur <= 0 || restPointRetur >= total) return false;
      return restPointRetur <= total;
    },
    isValidReturnPiutang2() {
      const userPaymentPiutang = this.userPaymentPiutang;
      if (!userPaymentPiutang) return false;

      // Coerce to numbers; fall back to 0 if undefined/null/NaN
      const amount = Number(userPaymentPiutang.amount) || 0;
      const unpaid   = Number(userPaymentPiutang.unpaid) || 0;
      const total  = Number(this.totalPengembalian) || 0;
      const restPiutang = unpaid
      if (restPiutang <= 0 || restPiutang >= total) return false;
      return restPiutang <= total;
    },
    isValidReturnWallet() {
      const userPaymentWallet = this.userPaymentWallet;
      if (!userPaymentWallet) return false;
      // Coerce to numbers; fall back to 0 if undefined/null/NaN
      const amount = Number(userPaymentWallet.amount) || 0;
      const used   = Number(userPaymentWallet?.total_return_wallet_amount) || 0;
      const total  = Number(this.totalPengembalian) || 0;
      const restWalletRetur = amount - used
      if (restWalletRetur <= 0 || restWalletRetur >= total) return false;

      return restWalletRetur <= total;
    },
    isValidReturnPiutang() {
      const userPaymentPiutang = this.userPaymentPiutang;
      if (!userPaymentPiutang) return false;

      // Coerce to numbers; fall back to 0 if undefined/null/NaN
      const amount = Number(userPaymentPiutang.amount) || 0;
      const unpaid   = Number(userPaymentPiutang.unpaid) || 0;
      const total  = Number(this.totalPengembalian) || 0;
      // const restWalletRetur = amount - unpaid
      // if (restWalletRetur >= amount) return false;

      return unpaid <= 0;
    },
    filteredPaymentsPointPiutang() {
      if (!this.results?.payments) return [];

      const success = this.results.status === 'success';
      const priorities = success
        ? ['point', 'piutang', 'wallet']
        : ['piutang', 'point', 'wallet'];

      const sortByPriority = (a, b) =>
        priorities.indexOf(a.payment_method) -
        priorities.indexOf(b.payment_method);

      return this.results.payments
        .filter(p => priorities.includes(p.payment_method))
        .sort(sortByPriority);
    },
    isDisabledPiutang() {
      const isPaymentSuccess = this.results.status === 'success'
      const isCustomerNull = this.results.customer === null;

      return ((!isPaymentSuccess && !isCustomerNull) || (!isPaymentSuccess && isCustomerNull) || this.userUnpaidPiutang !== 0) ? true : false
    },
    isWalletAndPiutangSplit() {
      const payments = this.results?.payments || [];
      const hasWallet = payments.some(p => p.payment_method === 'wallet');
      const hasPiutang = payments.some(p => p.payment_method === 'piutang');
      return hasWallet && hasPiutang;
    },
    walletPiutangSplitAmounts() {
      const piutangPayment = this.results?.payments?.find(p => p.payment_method === 'piutang');
      const walletPayment = this.results?.payments?.find(p => p.payment_method === 'wallet');
      const piutangMax = Number(piutangPayment?.unpaid || piutangPayment?.amount) || 0;
      const walletMax = Number(walletPayment?.amount) || 0;
      const total = Number(this.totalPengembalian) || 0;

      // Piutang priority
      const piutangShare = Math.min(total, piutangMax);
      const walletShare = Math.min(Math.max(total - piutangShare, 0), walletMax);

      return { piutang: piutangShare, wallet: walletShare };
    }
  },
  data() {
    const userPaymentPiutang = this.userPaymentPiutang
    return {
      money: {
        decimal: "",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      discountValue: 0,
      totalRetur: 0,
      returs: {},
      fields: ["name", "qty", "count", "normal_selling_value", "discount_per_item", "discount_per_invoice", "value", "condition"],
      items: [],
      qty: [],
      formPayload: {
        discount: 0,
        items: [
          // {
          //   uuid: '',
          //   qty: 0,
          //   condition: '',
          // },
        ],
        refund_method: "",
        payment_method_details: [
          {
            payment_method: userPaymentPiutang ? 'piutang' : 'point',
            amount: 0
          },
          {
            payment_method: null,
            amount: 0
          }
        ]
      },
      options: [
        { value: "", text: "Pilih Kondisi" },
        { value: "Baik", text: "Baik" },
        { value: "Rusak", text: "Rusak" },
      ],
      optionsBank: [
        { value: "cash", title: "Tunai" },
        { value: "transfer", title: "Transfer" },
        { value: "piutang", title: "Piutang" },
        { value: "wallet", title: "Deposit" },
        { value: "point", title: "Customer Point" },
      ],
      optionsBankSplit: {
        default: [
          { value: "piutang", title: "Piutang" },
        ],
        others: [
          { value: "cash", title: "Tunai" },
          { value: "transfer", title: "Transfer" },
          // { value: "wallet", title: "Deposit" },
        ],
      },
      optionsBankSplitPoint: {
        default: [
          { value: "point", title: "Customer Point" },
        ],
        others: [
          { value: "cash", title: "Tunai" },
          { value: "transfer", title: "Transfer" },
          // { value: "wallet", title: "Deposit" },
        ],
      },
      optionsBankSplitWallet: {
        default: [
          { value: "wallet", title: "Deposit" },
        ],
        others: [
          { value: "cash", title: "Tunai" },
          { value: "transfer", title: "Transfer" },
        ],
      },
      messages: "",
      id: "",
      isLoading: false,
      optionsBankPiutang: [
        { value: "cash", title: "Tunai", },
        { value: "transfer", title: "Transfer", },
      ]
    };
  },
  watch: {
    results: {
      handler(value) {
        this.messages = "";
        this.formPayload.items = [];
        this.items = [];
        this.qty = [];

        if (value) {
          if (this.returType === "order") {
            this.orderValue(value);
          }
          if (this.returType === "incoming_stock") {
            this.incomingStock(value);
          }
        }
        
        const updatedOptionsBank = this.optionsBank.map(option => {
          const isPaymentSuccess = value.status == 'success';
          const hasPaymentPiutang = value.payments?.some(payment => payment.payment_method === 'piutang');
          const isCustomerNull = value.customer === null;
          const hasPaymentPoint = value.payments?.some(payment => payment.payment_method === 'point');
          const hasPaymentWallet = value.payments?.some(payment => payment.payment_method === 'wallet');
          const paymentLength = value.payments?.length
          const itemPoint = hasPaymentPoint && value.payments.find(payment => payment.payment_method === 'point')
          const restPaymentPoint = itemPoint.amount - itemPoint.total_return_point_amount
          const isPaymentMethodPointAvailable = restPaymentPoint > 0

          if (!isPaymentSuccess) {
            if (hasPaymentPiutang) {
              if (option.value === 'piutang') {
                return {
                  ...option,
                  disabled: isCustomerNull || false
                };
              }

              if (option.value === 'wallet') {
                return {
                  ...option,
                  disabled: isCustomerNull || true
                };
              }
    
              if (option.value === 'cash') {
                return {
                  ...option,
                  disabled: isCustomerNull ? false : true
                };
              }
    
              if (option.value === 'transfer') {
                return {
                  ...option,
                  disabled: isCustomerNull ? false : true
                };
              }
              if (option.value === 'point') {
                return {
                  ...option,
                  disabled: true
                };
              }
            }

            if (hasPaymentPoint) {
              if (option.value === 'piutang') {
                return {
                  ...option,
                  disabled: true
                };
              }

              if (option.value === 'wallet') {
                return {
                  ...option,
                  disabled: true
                };
              }
    
              if (option.value === 'cash') {
                return {
                  ...option,
                  disabled: true
                };
              }
    
              if (option.value === 'transfer') {
                return {
                  ...option,
                  disabled: true
                };
              }
              if (option.value === 'point') {
                return {
                  ...option,
                  disabled: false
                };
              }
            }

            if (option.value === 'piutang') {
              return {
                ...option,
                disabled: isCustomerNull || hasPaymentPiutang
              };
            }
  
            if (option.value === 'wallet') {
              return {
                ...option,
                disabled: isCustomerNull
              };
            }

            return option
          }
          if (isPaymentSuccess) {
            if (hasPaymentPoint) {
              if (option.value === 'piutang') {
                return {
                  ...option,
                  disabled: true
                };
              }

              if (option.value === 'wallet') {
                return {
                  ...option,
                  disabled: true
                };
              }
    
              if (option.value === 'cash') {
                return {
                  ...option,
                  disabled: paymentLength === 1 ? true : isPaymentMethodPointAvailable
                };
              }
    
              if (option.value === 'transfer') {
                return {
                  ...option,
                  disabled: paymentLength === 1 ? true : isPaymentMethodPointAvailable
                };
              }
              if (option.value === 'point') {
                return {
                  ...option,
                  disabled: paymentLength === 1 ? false : hasPaymentPoint && !isPaymentMethodPointAvailable
                };
              }
            }

            if (hasPaymentWallet) {
              if (option.value === 'piutang') {
                return {
                  ...option,
                  disabled: true
                };
              }

              if (option.value === 'wallet') {
                return {
                  ...option,
                  disabled: paymentLength === 1 ? false : this.isValidReturnWallet
                };
              }
    
              if (option.value === 'cash') {
                return {
                  ...option,
                  disabled: paymentLength === 1 ? true : !this.isValidReturnWallet
                };
              }
    
              if (option.value === 'transfer') {
                return {
                  ...option,
                  disabled: paymentLength === 1 ? true : !this.isValidReturnWallet
                };
              }
              if (option.value === 'point') {
                return {
                  ...option,
                  disabled: true
                };
              }
            }

            if (option.value === 'piutang') {
              return {
                ...option,
                disabled: isCustomerNull || hasPaymentPiutang || true
              };
            }
  
            if (option.value === 'wallet') {
              return {
                ...option,
                disabled: isCustomerNull
              };
            }
  
            if (option.value === 'cash') {
              return {
                ...option,
                disabled: false
              };
            }
  
            if (option.value === 'transfer') {
              return {
                ...option,
                disabled: false
              };
            }

            if (option.value === 'point') {
              return {
                ...option,
                disabled: true
              };
            }
  
            return option;
          }

        });

        this.optionsBank = updatedOptionsBank;
      },
      deep: true,
    },
    qty: {
      handler(value) {
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < value.length; index++) {
          const element = value[index];
          // eslint-disable-next-line radix
          this.formPayload.items[index].qty =
            typeof element.qty === "string"
              ? parseFloat(preformatFloat(element.qty))
              : element.qty;
        }
        this.summaryReturTotal();
        
        const checkFilteredPaymentsPointPiutangIsValid = this.checkHasPointAndPiutang()
        if (this.$route.name === 'transaction.index' && checkFilteredPaymentsPointPiutangIsValid) {
          this.updatePaymentMethodDetails()
        }
      },
      deep: true,
    },
    discountValue(value) {
      const discountTotal = value.toString().replace(".", "");
      // eslint-disable-next-line radix
      this.formPayload.discount = parseInt(discountTotal);
    },
    userPaymentPiutang(item) {
      if (!item || !this.formPayload.payment_method_details) return;

      const idx = this.formPayload.payment_method_details.findIndex(
        (p) => p.uuid === item.uuid // or some unique key you have
      );
      if (idx !== -1) {
        this.$set(this.formPayload.payment_method_details, idx, {
          ...this.formPayload.payment_method_details[idx],
          payment_method: item.payment_method,
        });
      }
    },

    userPaymentWallet(item) {
      if (!item || !this.formPayload.payment_method_details) return;

      const idx = this.formPayload.payment_method_details.findIndex(
        (p) => p.uuid === item.uuid
      );

      if (idx !== -1) {
        this.$set(this.formPayload.payment_method_details, idx, {
          ...this.formPayload.payment_method_details[idx],
          payment_method: item.payment_method,
        });
      }
    },
  },
  mounted() {
    
  },
  methods: {
    updatePaymentMethodDetails() {
      const totalRetur = this.totalRetur || 0;
      let sisa = totalRetur;

      // Make sure array exists
      if (!Array.isArray(this.formPayload.payment_method_details)) {
        this.formPayload.payment_method_details = [];
      }

      // Ensure we have entries for piutang & point (if they exist in results)
      const payments = this.results?.payments || [];
      const methodsFromResults = payments
        .filter(p => ["piutang", "point"].includes(p.payment_method))
        .map(p => p.payment_method);

      // Seed payment_method_details based on payments if empty
      if (this.formPayload.payment_method_details.length === 0) {
        this.formPayload.payment_method_details = methodsFromResults.map(m => ({
          payment_method: m,
          amount: 0,
        }));
      }

      const piutangPayment = payments.find(p => p.payment_method === "piutang");
      const pointPayment   = payments.find(p => p.payment_method === "point");

      const maxPiutang = piutangPayment?.unpaid
        ? Number(piutangPayment.unpaid)
        : 0;

      const maxPoint =
        pointPayment?.amount
          ? Number(pointPayment.amount) -
            Number(pointPayment.total_return_point_amount || 0)
          : 0;

      this.formPayload.payment_method_details =
        this.formPayload.payment_method_details.map(detail => {
          if (detail.payment_method === "piutang") {
            const amount = Math.min(sisa, maxPiutang);
            sisa -= amount;
            return { ...detail, amount };
          }

          if (detail.payment_method === "point") {
            const amount = Math.min(sisa, maxPoint);
            sisa -= amount;
            return { ...detail, amount };
          }

          // other methods, if any
          return detail;
      });
    },
    getAvailableQty(uuid) {
      if (this.$route.name === 'retur.index') {
        const itemFromTransaction = this.findTransactionItemByUuid(uuid);
        const item = this.findItemByUuid(uuid);
        return itemFromTransaction ? Math.max(itemFromTransaction.qty - (itemFromTransaction.return_qty + item.return_qty || 0), 0).toFixed(2) : 0;
      } else {
        const itemFromItems = this.findItemByUuid(uuid);
        return itemFromItems ? Math.max(itemFromItems.qty - (itemFromItems.return_qty || 0), 0).toFixed(2) : 0;
      }
    },
    totalSumRetur(uuid) {
      const normalSellingValue = this.calculateValue(uuid, 'normal_selling_value');
      const discountPerInvoice = this.calculateValue(uuid, 'discount_per_invoice');
      const discountPerItem = this.calculateValue(uuid, 'discount_per_item');

      const total = normalSellingValue.toFixed(2) - discountPerInvoice.toFixed(2) - discountPerItem.toFixed(2);
      return total
    },
    findItemByUuid(uuid) {
      if (this.$route.name === 'retur.index') {
        return this.results.items.find(item => item.item.uuid === uuid);
      }

      if (this.$route.name === 'transaction.index') {
        return this.results.items.find(item => item.uuid === uuid);
      }
    },
    findFormPayloadItemByUuid(uuid) {
      return this.formPayload.items.find(item => item.uuid === uuid);
    },
    findTransactionItemByUuid(uuid) {
      return this.results.transaction?.items?.find(item => item.uuid === uuid);
    },
    calculateValue(uuid, type) {
      const calculations = {
        normal_selling_value: this.calculateNormalSellingValue,
        discount_per_item: this.calculateDiscountPerItem,
        discount_per_invoice: this.calculateDiscountPerInvoice
      };
      
      return calculations[type] ? calculations[type](uuid) : 0;
    },

    calculateNormalSellingValue(uuid) {
      const formItem = this.findFormPayloadItemByUuid(uuid)
      
      switch (this.currentPageType) {
        case 'retur.index':
          const item = this.findTransactionItemByUuid(uuid);
          return (item?.sub_price * formItem?.qty) || 0;
        case 'transaction.index':
          const itemFromItems = this.findItemByUuid(uuid);
          return (itemFromItems?.sub_price * formItem?.qty) || 0;
        default:
          return 0;
      }
    },

    calculateDiscountPerItem(uuid) {
      const formItem = this.findFormPayloadItemByUuid(uuid);
      
      switch (this.currentPageType) {
        case 'retur.index':
          const itemFromTransaction = this.findTransactionItemByUuid(uuid);
          return (itemFromTransaction?.discount_per_item || 0) * (formItem?.qty || 0);
        case 'transaction.index':
          const itemFromItems = this.findItemByUuid(uuid);
          return (itemFromItems?.discount_per_item || 0) * (formItem?.qty || 0);
        default:
          return 0;
      }
    },

    calculateDiscountPerInvoice(uuid) {
      switch (this.currentPageType) {
        case 'retur.index':
          return this.getReturInvoiceDiscount(uuid);
        case 'transaction.index':
          return this.getTransactionInvoiceDiscount(uuid);
        default:
          return 0;
      }
    },

    getReturInvoiceDiscount(uuid) {
      const item = this.findTransactionItemByUuid(uuid);
      const formItem = this.findFormPayloadItemByUuid(uuid);

      const subtotal = item?.subtotal || 0;
      const { discount_type, discount_value, subtotal: subTotalFromTransaction } = this.results.transaction;
      const proportion = parseFloat((subtotal / subTotalFromTransaction).toFixed(2));

      const discountPerInvoiceAmount = discount_value

      let discountPerInvoice = 0
      
      if (discount_type === 'percent') {
        const discountRate = Math.min(discountPerInvoiceAmount, 100);
        discountPerInvoice = (discountRate * subTotalFromTransaction) / 100
      } else {
        discountPerInvoice = discountPerInvoiceAmount
      }

      const discountPerInvoiceToItem =  (discountPerInvoice * proportion) / item.qty
      const totalDiscountPerInvoiceToItem = discountPerInvoiceToItem * formItem.qty

      return totalDiscountPerInvoiceToItem
    },

    getTransactionInvoiceDiscount(uuid) {
      const item = this.findItemByUuid(uuid)
      const formItem = this.findFormPayloadItemByUuid(uuid);

      const subtotal = item?.subtotal || 0;
      const { discount_type, discount_value, subtotal: subTotalFromTransaction } = this.results;
      const proportion = parseFloat((subtotal / subTotalFromTransaction).toFixed(2));

      const discountPerInvoiceAmount = discount_value

      let discountPerInvoice = 0
      
      if (discount_type === 'percent') {
        const discountRate = Math.min(discountPerInvoiceAmount, 100);
        discountPerInvoice = (discountRate * subTotalFromTransaction) / 100
      } else {
        discountPerInvoice = discountPerInvoiceAmount
      }

      const discountPerInvoiceToItem =  (discountPerInvoice * proportion) / item.qty
      const totalDiscountPerInvoiceToItem = discountPerInvoiceToItem * formItem.qty

      return totalDiscountPerInvoiceToItem
    },
    handleOpenModal() {
      if (this.results) {
        if (this.returType === "order") {
          this.orderValue(this.results);
        }
        if (this.returType === "incoming_stock") {
          this.incomingStock(this.results);
        }
      }
    },
    getRupiah(index) {
      const rupiah = document.getElementById(`v-jumlah-retur-${index}`);
      rupiah.value = formatRupiah(rupiah.value, "") || "";
      if (this.$route.name === 'transaction.index') {
        this.qty[index].qty = parseFloat(preformatFloat(rupiah.value)) || 0;
        this.formPayload.items[index].qty = parseFloat(
          preformatFloat(rupiah.value)
        );
      }
    },
    returCount(qty, index) {
      for (let j = 0; j < this.qty.length; j++) {
        const element = this.qty[j];
        // eslint-disable-next-line radix
        if (j === index && parseFloat(element.qty) > qty) {
          this.qty[index].qty = qty;
        }
      }
    },
    summaryReturTotal() {
      if (this.$route.name !== "retur.index") {
        this.formPayload.refund_method = null;
      }
      let total = 0;
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.items.length; index++) {
        const element = this.items[index];
        total += this.totalSumRetur(element.uuid);

      }
      this.totalRetur = total || 0;
    },
    async submit(type) {
      const confirmationText = this.getConfirmationText(type);
      this.$swal({
        title: "Konfirmasi",
        text: confirmationText,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true;
          const payload = { ...this.formPayload }; // shallow copy

          const isSplitPayment =
            this.totalPengembalian >= this.userUnpaidPiutang &&
            this.totalPengembalian !== this.userUnpaidPiutang;

          const amountPaymentMethod1 = this.userUnpaidPiutang
          const amountPaymentMethod2 = this.totalAmountPaymentMethodPiutang
          const isUserPaymentPiutangNull = this.userPaymentPiutang === null
          const isUserPaymentPointNull = this.userPaymentPoint === null
          const isSplitPaymentPointAndWallet = this.results?.payments?.length > 1
          const isPaymentPointPaidOff = this.userPaymentPoint && (this.userPaymentPoint.total_return_point_amount === this.userPaymentPoint.amount)

          const isUserPaymentWalletNull = this.userPaymentWallet === null
          const isPaymentWalletPaidOff = this.userPaymentWallet && (this.userPaymentWallet.total_return_wallet_amount === this.userPaymentWallet.amount)
          const isPaymentSuccess = this.results.status === 'success'  

          try {
            if (this.is_edit && type) {
              payload.status = type;
              payload._method = "PATCH";
              delete payload.payment_method_details
            }

            if (!this.is_edit) {
              // PIUTANG
              if (!isUserPaymentPiutangNull && isSplitPayment && !this.isTransactionSuccess && isUserPaymentPointNull && isUserPaymentWalletNull) {
                payload.refund_method = this.userPaymentPiutang?.payment_method;
                payload.payment_method_details = this.formPayload?.payment_method_details?.map((payment, index) => ({
                  ...payment,
                  amount: payment.payment_method === 'piutang' ? amountPaymentMethod1 : amountPaymentMethod2
                }))
                payload.is_split_payment_method = isSplitPayment ? 1 : 0;
              }
              if (!isUserPaymentPiutangNull && !isSplitPayment && !this.isTransactionSuccess && isUserPaymentPointNull && isUserPaymentWalletNull) {
                const unpaidPiutang = this.userPaymentPiutang?.unpaid
                const piutangAmount = this.totalAmountPaymentMethodPiutang
                const isPiutangUnpaidZero = unpaidPiutang === 0
                const isRefundLessOrEqualUnpaidPiutang = this.totalPengembalian <= unpaidPiutang
                
                payload.refund_method = this.isValidReturnPiutang ? this.formPayload.refund_method : this.userPaymentPiutang?.payment_method;
                payload.payment_method_details = this.formPayload?.payment_method_details
                  ?.map((payment) => {
                    return {
                      payment_method: payment.payment_method,
                      amount: payment.payment_method === 'piutang' && !isPiutangUnpaidZero ? (isRefundLessOrEqualUnpaidPiutang ? this.totalPengembalian : unpaidPiutang) : piutangAmount,
                    };
                  })
                  .filter(
                    (payment) =>
                      Number(payment.amount) > 0 && payment.payment_method !== null
                  );
                payload.is_split_payment_method = payload.payment_method_details.length === 1 ? 0 : 1;
              }
              if (!isUserPaymentPiutangNull && this.isTransactionSuccess && isUserPaymentPointNull && isUserPaymentWalletNull) {
                if (!this.formPayload?.payment_method_details[1]?.payment_method && !this.isValidReturnPiutang) {
                  errorNotification(this, "Oops!", 'Silahkan lengkapi data metode pembayaran');
                  return false
                }
                if (!this.formPayload.refund_method && this.isValidReturnPiutang) {
                  errorNotification(this, "Oops!", 'Silahkan lengkapi data metode pembayaran');
                  return false
                }
                const unpaidPiutang = this.userPaymentPiutang?.unpaid
                const piutangAmount = this.totalAmountPaymentMethodPiutang
                const isPiutangUnpaidZero = unpaidPiutang === 0
                const isRefundLessOrEqualUnpaidPiutang = this.totalPengembalian <= unpaidPiutang

                payload.refund_method = this.isValidReturnPiutang ? this.formPayload.refund_method : this.userPaymentPiutang?.payment_method;
                payload.payment_method_details = this.formPayload?.payment_method_details
                  ?.map((payment) => {
                    return {
                      payment_method: payment.payment_method === 'piutang' && this.isValidReturnPiutang ? this.formPayload.refund_method : payment.payment_method === 'cash' && this.isTransactionSuccess ? this.formPayload.refund_method : payment.payment_method,
                      amount: payment.payment_method === 'piutang' && !isPiutangUnpaidZero ? (isRefundLessOrEqualUnpaidPiutang ? this.totalPengembalian : unpaidPiutang) : piutangAmount,
                    };
                  })
                  .filter(
                    (payment) =>
                      Number(payment.amount) > 0 && payment.payment_method !== null
                  );
                payload.is_split_payment_method = payload.payment_method_details.length === 1 ? 0 : 1;
              }
              // POINT
              if (!isUserPaymentPointNull && this.isTransactionSuccess && isUserPaymentPiutangNull && isUserPaymentPiutangNull) {
                if (!this.formPayload?.payment_method_details[1]?.payment_method && !isPaymentPointPaidOff && this.isValidReturnPoint) {
                  errorNotification(this, "Oops!", 'Silahkan lengkapi data metode pembayaran');
                  return false
                }
                
                if (!this.formPayload.refund_method && !this.isValidReturnPoint) {
                  errorNotification(this, "Oops!", 'Silahkan lengkapi data metode pembayaran');
                  return false
                }
                payload.refund_method = !isSplitPaymentPointAndWallet || isPaymentPointPaidOff ? this.formPayload?.refund_method : this.userPaymentPoint?.payment_method;
                payload.payment_method_details = this.formPayload?.payment_method_details?.map((payment, index) => {
                  // const amountSplit = payment.payment_method === 'point' && !isPaymentPointPaidOff ? this.userPaymentPoint?.amount - this.userPaymentPoint?.total_return_point_amount : this.totalAmountPaymentMethodWithPoint
                  const amountNotSplit = payment.payment_method === 'point' && this.totalPengembalian < this.userPaymentPoint?.amount && this.totalPengembalian - this.totalAmountPaymentMethodWithPoint
                  
                  const isPointPaidZero = this.userPaymentPoint?.total_return_point_amount === 0
                  let amountSplit = 0;

                  if (payment.payment_method === 'point') {
                    amountSplit = isPointPaidZero
                      ? this.totalPengembalian - this.totalAmountPaymentMethodWithPoint
                      : this.totalPengembalian - this.totalAmountPaymentMethodWithPoint;
                  } else {
                    amountSplit = this.totalAmountPaymentMethodWithPoint;
                  }
                  return {
                    amount: amountSplit,
                    payment_method: payment.payment_method || this.formPayload.refund_method,
                  };
                }).filter(payment => Number(payment.amount) > 0 && payment.payment_method !== null)

                payload.is_split_payment_method = payload.payment_method_details.length === 1 ? 0 : 1;
              }
              // PIUTANG AND POINT
              if (!isUserPaymentPiutangNull && !isUserPaymentPointNull) {
                if (!this.formPayload?.payment_method_details[1]?.payment_method && !isPaymentPointPaidOff && this.totalPengembalian > this.userPaymentPoint?.amount) {
                  errorNotification(this, "Oops!", 'Silahkan lengkapi data metode pembayaran');
                  return false
                }
                if (!this.formPayload.refund_method && this.totalPengembalian <= this.userPaymentPoint?.amount && this.userPaymentPoint?.total_return_point_amount >= this.userPaymentPoint?.amount ) {
                  errorNotification(this, "Oops!", 'Silahkan lengkapi data metode pembayaran');
                  return false
                }
                const isPointPaidOff = this.userPaymentPoint?.total_return_point_amount >= this.userPaymentPoint?.amount;
                const isPiutangPaidOff = this.userPaymentPiutang?.unpaid === 0;
                
                if (isPaymentSuccess) {
                  payload.refund_method = isPiutangPaidOff && isSplitPaymentPointAndWallet && !isPaymentPointPaidOff ? this.userPaymentPoint?.payment_method : this.formPayload?.refund_method;
                  if (isPointPaidOff || !isPiutangPaidOff) {
                    // Point already fully returned → only 1 payment method: piutang
                    payload.payment_method_details = [
                      {
                        amount: this.totalPengembalian,
                        payment_method: this.formPayload.refund_method,
                      },
                    ];
                  } else {
                    const isPointPaidZero = this.userPaymentPoint?.total_return_point_amount === 0
                    payload.payment_method_details = this.formPayload?.payment_method_details
                      ?.map((payment) => {
                        let amountSplit = 0;

                        if (payment.payment_method === 'point') {
                          amountSplit = isPointPaidZero
                            ? this.totalPengembalian - this.totalAmountPaymentMethodWithPoint
                            : this.totalPengembalian - this.totalAmountPaymentMethodWithPoint;
                        } else {
                          amountSplit = this.totalAmountPaymentMethodWithPoint;
                        }
 
                        return {
                          amount: amountSplit,
                          payment_method: payment.payment_method,
                        };
                      })
                      .filter(
                        (payment) =>
                          Number(payment.amount) > 0 && payment.payment_method !== null
                      );
                  }
                } else {
                  payload.refund_method = this.isValidReturnPiutang ? this.formPayload.refund_method : this.userPaymentPiutang?.payment_method;
                  payload.payment_method_details = this.formPayload?.payment_method_details
                  ?.map((payment) => {
                    return {
                      payment_method: payment.payment_method,
                      amount: payment.amount,
                    };
                  })
                  .filter(
                    (payment) =>
                      Number(payment.amount) > 0 && payment.payment_method !== null
                  );
                }
                payload.is_split_payment_method = payload.payment_method_details.length === 1 ? 0 : 1;
              }

              // WALLET AND PIUTANG SPLIT
              if (!isUserPaymentWalletNull && !isUserPaymentPiutangNull && isUserPaymentPointNull) {
                const piutangPayment = this.results?.payments?.find(p => p.payment_method === 'piutang');
                const walletPayment = this.results?.payments?.find(p => p.payment_method === 'wallet');
                const piutangUnpaid = piutangPayment?.unpaid || piutangPayment?.amount || 0;
                const walletAmount = walletPayment?.amount || 0;

                // Distribute totalPengembalian: piutang first, then wallet for the rest
                const piutangShare = Math.min(this.totalPengembalian, piutangUnpaid);
                const walletShare = Math.min(Math.max(this.totalPengembalian - piutangShare, 0), walletAmount);

                const details = [];
                if (piutangShare > 0) {
                  details.push({ payment_method: 'piutang', amount: piutangShare });
                }
                if (walletShare > 0) {
                  details.push({ payment_method: 'wallet', amount: walletShare });
                }
                // If both are zero (totalPengembalian is 0), still send piutang
                if (details.length === 0) {
                  details.push({ payment_method: 'piutang', amount: 0 });
                }

                payload.payment_method_details = details;
                payload.refund_method = details[0].payment_method;
                payload.is_split_payment_method = details.length > 1 ? 1 : 0;
              }

              // Wallet
              if (!isUserPaymentWalletNull && this.isTransactionSuccess && isUserPaymentPiutangNull && isUserPaymentPointNull) {
                if (!this.formPayload?.payment_method_details[1]?.payment_method && !isPaymentWalletPaidOff && this.totalPengembalian > this.userPaymentWallet?.amount) {
                  errorNotification(this, "Oops!", 'Silahkan lengkapi data metode pembayaran');
                  return false
                }
                if (!this.formPayload.refund_method && this.totalPengembalian <= this.userPaymentPoint?.amount && this.userPaymentWallet?.total_return_wallet_amount >= this.userPaymentWallet?.amount) {
                  errorNotification(this, "Oops!", 'Silahkan lengkapi data metode pembayaran');
                  return false
                }
                payload.refund_method = !isSplitPaymentPointAndWallet || isPaymentWalletPaidOff ? this.formPayload?.refund_method : this.userPaymentWallet?.payment_method;
                const isWalletPaidZero = this.userPaymentWallet?.total_return_wallet_amount === 0
                payload.payment_method_details = this.formPayload?.payment_method_details
                  ?.map((payment) => {
                    let amountSplit = 0;

                    if (payment.payment_method === 'wallet') {
                      amountSplit = isWalletPaidZero
                        ? this.totalPengembalian - this.totalAmountPaymentMethodWithWallet
                        : this.totalPengembalian - this.totalAmountPaymentMethodWithWallet;
                    } else {
                      amountSplit = this.totalAmountPaymentMethodWithWallet;
                    }

                    return {
                      amount: amountSplit,
                      payment_method: payment.payment_method,
                    };
                  })
                  .filter(
                    (payment) =>
                      Number(payment.amount) > 0 && payment.payment_method !== null
                  );

                payload.is_split_payment_method = payload.payment_method_details.length === 1 ? 0 : 1;
              }

              // EXCEPT PIUTANG && POINT && WALLET
              if (isUserPaymentPiutangNull && isUserPaymentPointNull && isUserPaymentWalletNull) {
                if (!this.formPayload.refund_method) {
                  errorNotification(this, "Oops!", 'Silahkan lengkapi data metode pembayaran');
                  return false
                }

                payload.payment_method_details = [
                  {
                    amount: this.totalPengembalian,
                    payment_method: this.formPayload.refund_method,
                  }
                ]
                payload.is_split_payment_method = 0;
              }
            }

            payload.retur_type = this.returType;
            payload.items = payload.items.filter(item => item.qty);

            await this.$store.dispatch("returs/postData", {
              uuid: this.id,
              payload,
            });

            this.$bvModal.hide("modal-retur");
            successNotification(this, "Success", this.returnStatus(type));
            this.getData();
          } catch (err) {
            console.error(err);
            // errorNotification(this, "Oops!", err.response?.data?.meta?.messages)
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
    getConfirmationText(type) {
      if (this.is_edit === false && !type) {
        return `Apakah Anda yakin ingin membuat Retur ${this.returType === "incoming_stock" ? "pembelian" : "penjualan"
          } baru?`;
      }
      if (this.is_edit === true && !type) {
        return `Apakah Anda yakin ingin mengubah Retur ${this.returType === "incoming_stock" ? "pembelian" : "penjualan"
          } ini?`;
      }
      if (this.is_edit === true && type === "approve") {
        return `Apakah Anda yakin ingin menerima Retur ${this.returType === "incoming_stock" ? "pembelian" : "penjualan"
          } ini?`;
      }
      if (this.is_edit === true && type === "reject") {
        return `Apakah Anda yakin ingin menolak Retur ${this.returType === "incoming_stock" ? "pembelian" : "penjualan"
          } ini?`;
      }
      return "";
    },
    incomingStock(value) {
      this.id = this.is_edit === true ? value.uuid : "";
      this.returs = value;
      this.formPayload.retur_uuid = this.is_edit === true ? value.transaction.uuid : value.uuid;
      this.formPayload.discount = value.discount || 0;
      this.formPayload.refund_method = value.payment_method || null;
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.returs.items.length; index++) {
        const element = this.returs.items[index];
        this.qty.push({
          qty:
            this.is_edit === false
              ? ""
              : element.return_qty.toString().replace(".", ","),
          index,
        });
        this.formPayload.items.push({
          uuid: element.uuid || element.item?.uuid,
          qty: this.is_edit === false ? "" : element.return_qty,
          condition: this.is_edit === false ? "" : element.return_condition,
        });
        this.items.push({
          index,
          name: element.item?.product?.name || element.product?.name,
          qty:
            element.item?.qty.toString().replace(".", ",") ||
            element.qty.toString().replace(".", ","),
          count: "",
          value: "",
          condition: this.is_edit === false ? "" : element.return_condition,
          price:
            element.item && element.item.price
              ? element.item.price
              : element.price,
          uuid:
            element.item && element.item.uuid
              ? element.item.uuid
              : element.uuid,
          is_bonus: element.is_bonus || false,
        });
        setTimeout(() => {
          document.getElementById(`v-jumlah-retur-${index}`).focus()
          document.getElementById(`v-jumlah-retur-${index}`).value = element.return_qty || 0;
          this.getRupiah(index)
        }, 1000);
      }
    },
    checkHasPointAndPiutang() {
      const methods = this.filteredPaymentsPointPiutang.map(p => p.payment_method)
      const hasPoint = methods.includes('point')
      const hasPiutang = methods.includes('piutang')

      if (hasPoint && hasPiutang) {
        return true
      }
      return false
    },
    checkHasWalletAndPiutang() {
      const payments = this.results?.payments || [];
      const hasWallet = payments.some(p => p.payment_method === 'wallet');
      const hasPiutang = payments.some(p => p.payment_method === 'piutang');
      return hasWallet && hasPiutang;
    },
    checkHasPiutang() {
      const payments = this.results?.payments || [];
      const hasPiutang = payments.some(p => p.payment_method === 'piutang');
      const hasPoint = payments.some(p => p.payment_method === 'point');
      const hasWallet = payments.some(p => p.payment_method === 'wallet');
      return hasPiutang && !hasPoint && !hasWallet;
    },
    checkHasWallet() {
      const payments = this.results?.payments || [];
      const hasWallet = payments.some(p => p.payment_method === 'wallet');
      const hasPoint = payments.some(p => p.payment_method === 'point');
      const hasPiutang = payments.some(p => p.payment_method === 'piutang');
      return hasWallet && !hasPoint && !hasPiutang;
    },
    orderValue(value) {
      this.id = this.is_edit === true ? value.uuid : "";
      this.returs = value;
      this.formPayload.retur_uuid = this.is_edit === true ? value.transaction.uuid : value.uuid;
      this.formPayload.discount = value.discount || 0;
      this.formPayload.refund_method = value.payment_method || null;


      const checkFilteredPaymentsPointPiutangIsValid = this.checkHasPointAndPiutang()
      if (this.$route.name === 'transaction.index' && checkFilteredPaymentsPointPiutangIsValid) {
        this.formPayload.payment_method_details = this.filteredPaymentsPointPiutang.map(item => {
          return {
            payment_method: item.payment_method === 'piutang' && this.results.status === 'success' ? 'cash' : item.payment_method,
          }
        })
      }

      const checkOnlyHasPiutang = this.checkHasPiutang()
      if (this.$route.name === 'transaction.index' && checkOnlyHasPiutang) {
        this.formPayload.payment_method_details = this.results.payments.map(item => {
          if (this.results.status === 'success') {
            return {
              payment_method: item.payment_method === 'piutang' && this.results.status === 'success' ? 'cash' : null,
            }
          } else {
            return {
              payment_method: item.payment_method === 'piutang' && this.results.status !== 'success' ? 'piutang' : item.payment_method,
            }
          }
        }).sort((a, b) => {
          if (a.payment_method === 'piutang') return -1; // Moves 'a' to the front
          if (b.payment_method === 'piutang') return 1;  // Moves 'b' to the front
          return 0; // Keeps original order for other methods
        })
      }

      const checkOnlyHasWallet = this.checkHasWallet()
      if (this.$route.name === 'transaction.index' && checkOnlyHasWallet) {
        this.formPayload.payment_method_details = this.results.payments.map(item => {
          return {
            payment_method: item.payment_method === 'wallet' ? 'wallet' : null,
          }
        })
      }

      const checkHasWalletAndPiutang = this.checkHasWalletAndPiutang()
      if (this.$route.name === 'transaction.index' && checkHasWalletAndPiutang) {
        // wallet first, then piutang — mirrors sortedPaymentWalletPiutang
        this.formPayload.payment_method_details = this.results.payments
          .slice()
          .sort((a, b) => {
            const order = ['piutang', 'wallet'];
            return order.indexOf(a.payment_method) - order.indexOf(b.payment_method);
          })
          .map(item => ({
            payment_method: item.payment_method, // 'wallet' or 'piutang'
            amount: item.payment_method === 'wallet' ? (item.amount || 0) : (item.unpaid || item.amount || 0),
          }))
      }


      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.returs.items.length; index++) {
        const element = this.returs.items[index];
        const itemUuid = this.is_edit === false ? element.uuid : element.item.uuid;

        // Cari item pendamping di transaction.items jika dibuka dari retur.index
        const transactionItems = this.results?.transaction?.items || [];
        const matchTxItem = transactionItems.find(tx => tx.uuid === itemUuid);

        // Penentuan status bonus (dari element, element.item, transaction.items, atau jika harga 0)
        const isBonus = this.is_edit === false ? (element.is_bonus || element.price === 0) : ( element.is_bonus || element.item?.is_bonus || matchTxItem?.is_bonus || element.item?.price === 0);
        this.qty.push({
          qty:
            this.is_edit === false
              ? ""
              : element.return_qty.toString().replace(".", ","),
          index,
        });
        this.formPayload.items.push({
          uuid: this.is_edit === false ? element.uuid : element.item.uuid,
          qty: this.is_edit === false ? "" : element.return_qty,
          condition: this.is_edit === false ? "" : element.return_condition,
        });
        this.items.push({
          index,
          name: this.is_edit === false ? element.name : element.item.name,
          qty:
            this.is_edit === false
              ? element.qty.toString().replace(".", ",")
              : element.item.qty.toString().replace(".", ","),
          count: "",
          value: "",
          condition: this.is_edit === false ? "" : element.return_condition,
          price: this.is_edit === false ? element.price : element.item.price,
          uuid: this.is_edit === false ? element.uuid : element.item.uuid,
          is_bonus: Boolean(isBonus),
        });
        setTimeout(() => {
          if (this.$route.name === 'transaction.index') {
            document.getElementById(`v-jumlah-retur-${index}`).focus()
            document.getElementById(`v-jumlah-retur-${index}`).value = 0;
            // document.getElementById(`v-jumlah-retur-${index}`).value = Math.max(element.qty - (element.return_qty || 0), 0) || "";
            this.getRupiah(index)  
          }
          if (this.$route.name === 'retur.index') {
            document.getElementById(`v-jumlah-retur-${index}`).value = element?.return_qty  || 0
          }
        }, 1000);
      }
    },
    returnStatus(type) {
      if (this.is_edit === false && !type) {
        return `Berhasil menambahkan retur ${this.returType === "incoming_stock" ? "pembelian" : "penjualan"
          }!`;
      }
      if (this.is_edit === true && !type) {
        return `Berhasil mengubah retur ${this.returType === "incoming_stock" ? "pembelian" : "penjualan"
          }!`;
      }
      if (this.is_edit === true && type === "approve") {
        return `Retur ${this.returType === "incoming_stock" ? "pembelian" : "penjualan"
          } diterima!`;
      }
      if (this.is_edit === true && type === "reject") {
        return `Retur ${this.returType === "incoming_stock" ? "pembelian" : "penjualan"
          } ditolak!`;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";
@import "@core/scss/vue/libs/vue-select.scss";
.split--group {
  .vs__search {
    display: none;
  }

}
.bg-dark {
  background: $dark !important;
}

.btn-reject {
  background-color: #ffeeee !important;
  border-radius: 8px;
  color: #ff2929 !important;
  border: none !important;

  &:focus {
    background-color: #ffeeee !important;
  }
}

.text-error {
  color: #f48989;
}

#modal-retur {
  .modal-dialog {

    .modal-content {

      .modal-body {

        .custom__input {
          &.error-validation {
            background: #feefef;
            border: 1px solid #f48989;

            .input-group-text {
              background-color: #feefef !important;
              border: 1px solid #f48989 !important;
            }
          }
        }

        label {
          font-size: 14px;
          color: $dark;
          font-weight: 600;
        }

        .vs__open-indicator {
          fill: rgba(60, 60, 60, 0.5);
        }

        .custom__input {
          height: 52px;
          background: #eff1f5;
          border: 1px solid #e4e5ec;
          border-radius: 8px;
        }

        .vs__dropdown-toggle {
          height: 52px;
          background-color: #eff1f5;
          border: 1px solid #e4e5ec;
          border-radius: 8px;
        }

        table {
          thead {
            tr {
              th {
                border-bottom: 1px solid #ebe9f1;
                background-color: transparent;
                border-top: none;
                color: #7a7f94;
                text-transform: capitalize;
                font-size: 14px;
              }
            }
          }

        }

        .footer__purchase {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          background: #ffffff;
          box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.04);
          border-radius: 16px 16px 0px 0px;
        }
      }
    }
  }
}
</style>